export { JointUtilization as default } from '@/components/enpages/Legal/JointUtilization'
